import { createStore } from 'vuex'

export default createStore({
    state: {
        formStep: 1,

        doorType: 'hinge',

        doorHeight: 220,
        doorWidth: 80,
        
        doorHeightMin: 190,
        doorHeightMax: 300,
        doorWidthMin: 70,
        doorWidthMax: 110,

        doorAmount: 1,
        doorBeamAmount: 0,
        doorUprightAmount: 0,

        sidePanelAmount: 'none',
        sidePanelWidth: 60,
        sidePanelWidthMin: 40,
        sidePanelWidthMax: 100,
        sidePanelBeamAmount: 0,
        sidePanelUprightAmount: 0,

        frameColor: '9005',
        glassType: 'basic',
        doorHandleType: 'levem',

        contactForm: {
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            address: "",
            zip: "",
            city: "",
            country: "",
            vat: "",
            company: "",
            vatNumber: "",
            remark: "",
            gdprCheck: false,
        },

        snapShot: 'false',
        imageUrl: ''
    },
    mutations: {
        formStepNext(state) {
            state.formStep++;
        },
        formStepPrev(state) {
            state.formStep--;
        },


        setDoorType(state) {
            state.doorType = event.currentTarget.id;
        },
        setDoorHeight(state, value) {
            state.doorHeight = value;
        },
        setDoorWidth(state, value) {
            state.doorWidth = value;
        },
        setDoorHeightMin(state, value) {
            state.doorHeightMin = value;
        },
        setDoorWidthMax(state, value) {
            state.doorWidthMax = value;
        },
        setDoorAmount(state, value) {
            state.doorAmount = value + 1;
        },


        setSidePanelAmount(state) {
            state.sidePanelAmount = event.currentTarget.id;
        },
        setSidePanelWidth(state, value) {
            state.sidePanelWidth = value;
        },


        setDoorBeamAmount(state, value) {
            state.doorBeamAmount = value;
        },
        setDoorUprightAmount(state, value) {
            state.doorUprightAmount = value;
        },


        setSidePanelBeamAmount(state, value) {
            state.sidePanelBeamAmount = value;
        },
        setSidePanelUprightAmount(state, value) {
            state.sidePanelUprightAmount = value;
        },


        setFrameColor(state) {
            state.frameColor = event.currentTarget.id;
        },

        
        setGlassType(state) {
            state.glassType = event.currentTarget.id;
        },


        setDoorHandleType(state) {
            state.doorHandleType = event.currentTarget.id;
        },
        setDoorHandleOption(state, value) {
            state.obj.doorHandleOption = value;
        },
        
        setContactForm(state, value) {
            state.first_name = value
            state.last_name = value
            state.email = value
            state.phone = value
            state.address = value
            state.areaCode = value
            state.city = value
            state.country = value
            state.vat = value
            state.company = value
            state.vat_number = value
            state.remark = value
            state.gdpr_check = value
        },

        setSnapShot(state, value) {
            state.snapShot = value
        },

        setImageUrl(state, value) {
            state.imageUrl = value
        }
        
    },
    getters: {},
    actions: {},
    modules: {},
})
